'use client';

import { CmsOffer } from '@hyphengroup/cms-components/types/cmsProduct';
import { tr } from '@hyphengroup/cms-components/utils/translations/tr';
import { ApplyStaticText } from '$/(cms)/-cms/apply-v3/[[...slugs]]/i18n';
import Button from '$/components/Button';
import { useClientContext } from '$/modules/context/client';
import { getClientTranslations } from '$/modules/i18n/client.index';

type Props = {
  selectedOffer: CmsOffer | undefined;
  onApplyWithBundle: (label: string) => void;
  onApplyWithoutBundle: (label: string) => void;
};

export function BundleUpsellFooter({
  selectedOffer,
  onApplyWithBundle,
  onApplyWithoutBundle,
}: Props) {
  const context = useClientContext();
  const staticText = getClientTranslations(ApplyStaticText, context);

  const primaryCtaLabel = selectedOffer
    ? tr('applyWithBundle', staticText, {
        bundleName: selectedOffer.offer_title,
      })
    : staticText.selectBundleAbove;

  return (
    <div className="grid w-full shrink-0 grid-cols-1 gap-3 md:grid-cols-2 md:gap-2">
      <Button
        className="min-h-11 w-full justify-center whitespace-normal break-words rounded-md p-3 text-center font-semibold text-base leading-5"
        disabled={!selectedOffer}
        onClick={() => onApplyWithBundle(primaryCtaLabel)}
        styleType="cta"
        type="button"
      >
        {primaryCtaLabel}
      </Button>
      <Button
        className="min-h-11 w-full justify-center whitespace-normal break-words rounded-md p-3 text-center font-semibold text-base leading-5"
        onClick={() => onApplyWithoutBundle(staticText.applyForCardOnly)}
        styleType="neutral-light-and-blue"
        type="button"
        variant="outline"
      >
        {staticText.applyForCardOnly}
      </Button>
    </div>
  );
}
